export const getEventPayload = (visitorUid: string | null, userId?: number) => {
  return { user_id: userId, visitor_uid: visitorUid ? visitorUid : undefined };
};
